import { useEffect, useState } from "react";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import ProductsSection from "./components/ProductsSection";
import FeaturesSection from "./components/FeaturesSection";
import CTASection from "./components/CTASection";
import TestimonialsSection from "./components/TestimonialsSection";
import { fetchHomeData, type HomeData, type Slide } from "../../api";

export default function Home() {
  const [data, setData] = useState<HomeData | null>(null);
  const [slides, setSlides] = useState<Slide[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchHomeData()
      .then((d) => {
        setData(d);
        setSlides(d.slides);
      })
      .catch((err) => {
        console.warn("首页数据加载失败，使用默认数据:", err);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection slides={slides} />
        <AboutSection data={data?.about ?? null} />
        <ProductsSection data={data?.products ?? null} />
        <FeaturesSection data={data?.features ?? null} />
        <CTASection data={data?.cta ?? null} />
        <TestimonialsSection data={data?.testimonials ?? null} />
      </main>
      <Footer />
    </div>
  );
}